module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-markdown",
    class: {
      'focus': _vm.focus,
      'has-value': _vm.value && _vm.value.length,
      'has-error': _vm.error && _vm.error.length,
      'disabled': _vm.$props.disabled,
      'readonly': _vm.$props.readonly
    }
  }, [_c('div', {
    staticClass: "z-markdown-container"
  }, [(_vm.$props.label) ? _c('label', {
    attrs: {
      "for": _vm.$props.id
    }
  }, [_vm._v(_vm._s(_vm.$props.label + ((_vm.$props.required) ? ' *' : '') + (_vm.$props.readonly ? ' (только для чтения)' : '') + (_vm.$props.loading ? ' (загрузка)' : '')))]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "preview",
    domProps: {
      "innerHTML": _vm._s(_vm.previewText)
    },
    on: {
      "click": _vm.edit
    }
  }), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "editarea",
    staticClass: "edit-area",
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  })]), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b02c137","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZMarkdown.vue
// module id = 1088
// module chunks = 0